export default __webpack_public_path__ + "static/media/filling_3.be2c8c75.jpg";